import axios from './configAxios';

export const getOneEntryReportApi = async (reportId) => {
	return await axios.get(`/${reportId}`);
};
